import apiSlice from '../api/api.slice';

export interface ISpotlightCreator {
  _id: string;
  username: string;
  firstname: string;
  lastname: string;
  profilePicture: string | null;
  isOnefinityOfficial: boolean;
}

export type ISpotlightFileKind = 'post' | 'projectGroup';

export interface ISpotlightFile {
  _id: string;
  /** Which detail route the card links to: /model/:id or /project-groups/:id. */
  kind: ISpotlightFileKind;
  title: string;
  /** Already resolved: admin upload if one exists, else the post thumbnail. */
  heroImage: string | null;
  usesCustomImage: boolean;
  user: ISpotlightCreator | null;
}

interface ISpotlightPublic {
  creatorOfTheMonth: ISpotlightCreator | null;
  fileOfTheWeek: ISpotlightFile | null;
}

const spotlightApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSpotlight: builder.query<ISpotlightPublic, void>({
      query: () => ({ url: '/api/v1/spotlight' }),
      transformResponse: (res: { spotlight: ISpotlightPublic }) =>
        res.spotlight,
    }),
  }),
});

export const { useGetSpotlightQuery } = spotlightApiSlice;
